/*! Copyright (c) Safe As Milk. All rights reserved. */
class ImageSkeleton extends HTMLElement {
    #loadStartTime;
    #minimumRevealDelay;
    #revealTimeout;
    #image;
    #boundOnImageResolved;
    connectedCallback() {
        if (this.hasAttribute("loaded")) return;
        this.#minimumRevealDelay = Number(this.getAttribute("minimum-reveal-delay") || 0);
        this.#revealTimeout = null;
        this.#image = null;
        this.#boundOnImageResolved = this.#onImageResolved.bind(this);
        this.#loadStartTime = Date.now();
        this.init();
    }
    disconnectedCallback() {
        if (this.#revealTimeout) clearTimeout(this.#revealTimeout);
        if (this.#image) {
            this.#image.removeEventListener("load", this.#boundOnImageResolved);
            this.#image.removeEventListener("error", this.#boundOnImageResolved);
        }
    }
    init() {
        this.#image = this.nextElementSibling && this.nextElementSibling.tagName === "IMG" ? this.nextElementSibling : null;
        if (!this.#image) return;
        this.#image.addEventListener("load", this.#boundOnImageResolved, {
            once: true
        });
        this.#image.addEventListener("error", this.#boundOnImageResolved, {
            once: true
        });
        if (this.#image.hasAttribute("src") && this.#image.complete) {
            this.#onImageResolved();
            return;
        }
        requestAnimationFrame((() => {
            if (this.#image && this.#image.hasAttribute("src") && this.#image.complete) this.#onImageResolved();
        }));
    }
    #onImageResolved() {
        if (this.hasAttribute("loaded")) return;
        if (this.#revealTimeout) clearTimeout(this.#revealTimeout);
        const elapsed = Date.now() - this.#loadStartTime;
        const remainingDelay = Math.max(0, this.#minimumRevealDelay - elapsed);
        this.#revealTimeout = setTimeout((() => {
            this.markAsLoaded();
        }), remainingDelay + 250);
    }
    markAsLoaded() {
        this.setAttribute("loaded", "");
        this.setAttribute("aria-hidden", "true");
    }
}

customElements.define("image-skeleton", ImageSkeleton);
//# sourceMappingURL=image-skeleton.js.map
